module.exports = __webpack_public_path__ + "static/media/MetaClan-Pokemol-Background.b5647a35.jpg";